<template>
  <div class="rule">
    <div>
      <van-nav-bar
        @click-left="navTo('/room/1')"
        @click-right="navTo('/')"
        fixed
        placeholder
        :title="$t('nav.rule')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
        <template #right>
          <van-icon color="#000" name="wap-home-o" />        
        </template>
      </van-nav-bar>
    </div>

    <div style="padding: 5px;">
      <div>
        <h1 style="font-size: 20px;">{{ $t('rule.title') }}</h1>
      </div>
      <div style="text-align: left;font-size: 12px / 1.5 'Microsoft YaHei', tahoma, arial, sans-serif;">
        <p style="padding: 4px;font-size: 16px">
          {{ $t('rule.p1') }}
          <br>
          {{ $t('rule.p2') }}
          <br>
          {{ $t('rule.p3') }}
          <br>
          {{ $t('rule.p4') }}
          <br>
          {{ $t('rule.p5') }}
          <br>
          {{ $t('rule.p6') }}
          <br>
          {{ $t('rule.p7') }}
          <br>
          {{ $t('rule.p8') }}
          <br>
          {{ $t('rule.p9') }}
          <br>
          {{ $t('rule.p10') }}
          <br>
          {{ $t('rule.p11') }}
          <br>
          {{ $t('rule.p12') }}
          <br>
          {{ $t('rule.p13') }}
          <br>
          {{ $t('rule.p14') }}
          <br>
          {{ $t('rule.p15') }}
          <br>
          {{ $t('rule.p16') }}
          <br>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rule",
  methods: {
    navTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style></style>
